import type { RouteRecordRaw } from 'vue-router'

export const usersRoutes: RouteRecordRaw[] = [
  {
    path: '/users',
    meta: {
      layout: 'dash',
      protected: true,
      permissions: ['PROTECT'],
    },
    children: [
      {
        path: 'profile/:tab?',
        name: 'users.profile',
        component: () => import('@/pages/users/Profile'),
      },
    ],
  },
]
